import axios from '../modules/axios';
import { debounce } from '../util';

export default {
	namespaced: true,
	state: {
    open: false,
    articles: [],
    products: '',
    query: '',
    waitGroup: 0,
	},
	mutations: {
		articles(state, articles) {
			state.articles = articles;
    },
    products(state, products) {
			state.products = products;
		},
		open(state, open) {
			state.open = open;
    },
    query(state, query) {
      state.query = query;
    },
    waitGroup(state, count) {
      state.waitGroup = count;
    }
	},
	actions: {
    search: debounce(async ({ commit, state }) => {
      const query = state.query;
      commit('waitGroup', state.waitGroup + 1);

      const searchResults = await Promise.all([
        axios(`/search?view=ajax&q=${query}*&type=product`),
        axios(`/search?view=ajax&q=${query}*&type=article`)
      ]);

      commit('waitGroup', state.waitGroup - 1);

      // if user has changed query during the request, do nothing
      if (query !== state.query) return;

      commit('products', searchResults[0].data);
      commit('articles', searchResults[1].data);
    }, 250)
	},
	getters: {
    waitGroup(state) {
      return state.waitGroup
    },
    loading(state) {
      return state.waitGroup > 0
    },
		articles(state) {
			return state.articles.filter(article => !article.ambassador)
    },
    ambassadors(state) {
      return state.articles.filter(article => article.ambassador)
    },
    products(state) {
      return state.products;
    },
		open(state) {
			return state.open;
    },
    query(state) {
      return state.query;
    }
	}
}
